module.exports = __webpack_public_path__ + "media/images/ballet-4392561705ddae5341a45f64435d44b9.jpg";